import moment from 'moment-timezone'

export const untilStart = (start, withoutSuffix = true) => {
  const startMoment = moment(start).tz(moment.tz.guess())
  return startMoment.diff(moment()) < 0
    ? null
    : startMoment.fromNow(withoutSuffix)
}

export const fromNow = (date, withoutSuffix = false) => {
  return moment.tz(date, moment.tz.guess()).fromNow(withoutSuffix)
}

// formats month/year parts as localized "MMMM YYYY"

export const formatMonthYearFromParts = (month, year, locale = 'en') => {
  if (month == null && year == null) return ''

  const monthNum = typeof month === 'number' ? month : Number(month)
  const yearNum = typeof year === 'number' ? year : Number(year)

  const validMonth = !Number.isNaN(monthNum) && monthNum >= 1 && monthNum <= 12
  const validYear = !Number.isNaN(yearNum)

  if (validMonth && validYear) {
    const date = moment.tz(
      { year: yearNum, month: monthNum - 1, day: 1 },
      'UTC',
    )
    date.locale(locale === 'es' ? 'es' : 'en')
    return date.format('MMMM YYYY')
  }

  return [month, year].filter(Boolean).join(' ')
}

export default {
  formatMonthYearFromParts,
  untilStart,
  fromNow,
}
